module.exports = __webpack_public_path__ + "static/img/WAIT_TO_URINATE.f22dfd4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/state-ui/WAIT_TO_URINATE.gif
// module id = 1Tuy
// module chunks = 1